import Swiper, { Autoplay, EffectFade } from 'swiper'

import 'swiper/swiper.scss'
import 'swiper/components/effect-fade/effect-fade.scss'
;(() => {
  Swiper.use([Autoplay, EffectFade])

  const heroSwiper = document.querySelector('.s-home-hero__swiper')
  if (!heroSwiper) {
    return
  }
  const { autoplay, autoplaySpeed = 3000 } = heroSwiper.dataset
  const options = {
    effect: 'fade',
    loop: true,
    speed: 1000,
  }
  if (autoplay === 'true') {
    options.autoplay = {
      delay: autoplaySpeed,
    }
  }
  new Swiper('.s-home-hero__swiper-container', options)
})()
